import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Callout, DataListItem } from '@node-space/ui-components'
import { MappedErrorMessageState } from 'types/errors'

interface EarnReviewDataItem {
  id: string
  label: string
  value: string
}

interface EarnReviewProps {
  data: EarnReviewDataItem[]
  requestError: MappedErrorMessageState
  isPending: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const EarnReview = ({
  data,
  requestError,
  isPending,
  onCancel,
  onConfirm,
}: EarnReviewProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gapY={16} width="full" paddingY={24}>
      {requestError?.show && (
        <Callout variant="error" testId="review-error-callout">
          {requestError?.handledMessage}
        </Callout>
      )}

      <Box flexCol>
        {data.map(item => (
          <DataListItem
            key={item.id}
            id={item.id}
            testId={`review-${item.id}`}
            title={t(item.label)}
            body={item.value}
          />
        ))}
      </Box>

      <Box flex justify="between" gapX={12} paddingT={24}>
        <Button
          onClick={onCancel}
          variant="secondary"
          type="button"
          testId="cancel-button"
          disabled={isPending}
        >
          {t('cancel')}
        </Button>
        <Button
          variant="primary"
          type="button"
          testId="confirm-button"
          disabled={isPending}
          loading={isPending}
          onClick={onConfirm}
        >
          {t('confirm')}
        </Button>
      </Box>
    </Box>
  )
}
